import { colors } from '@everlywell/leaves';
import { css } from 'styled-components';

const LinkStyles = css`
  transition: 0.2s;
  text-decoration: none;
  cursor: pointer;
  color: ${colors.teal4};

  &:hover {
    color: ${colors.teal4};
    text-decoration: underline;
  }

  &:active {
    color: ${colors.teal4};
    text-decoration: none;
  }

  &:focus {
    color: ${colors.teal4};
    text-decoration: underline;
    outline: none;

    &:active {
      color: ${colors.teal4};
      text-decoration: none;
    }
  }
`;

export default LinkStyles;
